import { useForm } from 'react-hook-form';
import { FormProvider, TextField } from '../../../../../components';
import { Button, Grid, Stack, Typography, Box ,IconButton } from '@mui/material';
import { yupResolver } from '@hookform/resolvers/yup';
import CloseIcon from '@mui/icons-material/Close';
import * as Yup from 'yup';

export const MedicalHistory = ({ onAdd, onClose, setMedicalHistoryDialog }) => {
  const methods = useForm({
    resolver: yupResolver(
      Yup.object().shape({
      
      })
    ),
    mode: 'all',
  });
  const { handleSubmit, reset } = methods;

  const formSubmit = (formValue) => {
    onAdd(formValue);
    setMedicalHistoryDialog(false);
  };

  return (
    <FormProvider methods={methods} onSubmit={handleSubmit(formSubmit)}>
       <Stack direction="row" spacing={0} alignItems="center" justifyContent="space-between" sx={{ marginBottom:2,borderBottom: 1, borderColor: 'grey.300', paddingBottom: 2 }}>
        <Typography variant="h4" fontWeight="bold" sx={{marginBottom:"2%"}}>
          Medical History
        </Typography>
        <IconButton onClick={onClose}>
          <CloseIcon color="error" fontSize="large" />
        </IconButton>
      </Stack>
      <Grid container spacing={3}>
        {/* Left Side */}
        <Grid item xs={12} sm={6}>
          <Stack spacing={14}>
            <Stack spacing={1} direction="row" alignItems="center">
              <Typography sx={{ width: '120px', fontWeight: 600, fontSize: '1.2rem' }}>T.B</Typography>
              <TextField fullWidth variant="outlined" name="tb" placeholder="Enter TB details" />
            </Stack>

            <Stack spacing={1} direction="row" alignItems="center">
              <Typography sx={{ width: '120px', fontWeight: 600, fontSize: '1.2rem' }}>D.M</Typography>
              <TextField fullWidth variant="outlined" name="dm" placeholder="Enter Dysmenorrhea (DM) details" />
            </Stack>

            <Stack spacing={1} direction="row" alignItems="center">
              <Typography sx={{ width: '120px', fontWeight: 600, fontSize: '1.2rem' }}>H.T</Typography>
              <TextField fullWidth variant="outlined" name="ht" placeholder="Enter HT details" />
            </Stack>
          </Stack>
        </Grid>

        {/* Right Side */}
        <Grid item xs={12} sm={6}>
          <Stack spacing={3}>
            <Stack spacing={1} direction="row" alignItems="center">
              <Typography sx={{ width: '120px', fontWeight: 600, fontSize: '1.2rem' }}>Fix</Typography>
              <TextField fullWidth variant="outlined" name="tb_fix" multiline rows={3} placeholder="Enter Fix details" />
            </Stack>

            <Stack spacing={1} direction="row" alignItems="center">
              <Typography sx={{ width: '120px', fontWeight: 600, fontSize: '1.2rem' }}>Years</Typography>
              <TextField fullWidth variant="outlined" name="dm_years" placeholder="Enter Years" />
            </Stack>

            <Stack spacing={1} direction="row" alignItems="center">
              <Typography sx={{ width: '120px', fontWeight: 600, fontSize: '1.2rem' }}>Fix</Typography>
              <TextField fullWidth variant="outlined" name="dm_fix" multiline rows={3} placeholder="Enter Fix details" />
            </Stack>

            <Stack spacing={1} direction="row" alignItems="center">
              <Typography sx={{ width: '120px', fontWeight: 600, fontSize: '1.2rem' }}>Details</Typography>
              <TextField fullWidth variant="outlined" name="ht_details" multiline rows={3} placeholder="Enter additional details" />
            </Stack>
          </Stack>
        </Grid>
      </Grid>

      <Stack spacing={2} direction="row" alignItems="center" justifyContent="flex-start" sx={{ marginTop: 3 }}>
        <Typography sx={{ width: '120px', fontWeight: 600, fontSize: '1.2rem' }}>Other</Typography>
        <TextField fullWidth variant="outlined" name="other" multiline rows={3} placeholder="Enter other details" />
      </Stack>

      <Box sx={{ display: 'flex', justifyContent: 'flex-end', marginTop: 3 }}>
        <Button variant="contained" type="submit" sx={{ marginRight: 2 }}>
          Add
        </Button>
        <Button color="error" onClick={onClose}>
          Close
        </Button>
      </Box>
    </FormProvider>
  );
};
